import axios from 'axios';
import { Mensaje } from '@/interfaces/Mensaje';

interface PaginatedResponse<T> {
    data: T[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
    from: number;
    to: number;
}

export abstract class MensajesApi {
    static async getMensajes(page = 1, perPage = 20): Promise<PaginatedResponse<Mensaje>> {
        const response = await axios.get(`mensajes?page=${page}&per_page=${perPage}`)
        return response.data
    }

    static async getMensajesData(page = 1, perPage = 20): Promise<Mensaje[]> {
        const response = await this.getMensajes(page, perPage)
        return response.data || []
    }

    static async searchMensajes(term: string, page = 1, perPage = 20): Promise<PaginatedResponse<Mensaje>> {
        const response = await axios.get(`mensajes/search?term=${encodeURIComponent(term)}&page=${page}&per_page=${perPage}`)
        return response.data
    }
    static async setLeido(myMensaje: Mensaje) {
        const response = await axios.post('mensajes/setLeido/' + myMensaje.id)
        return response.data
    }
    static async setNoLeido(myMensaje: Mensaje) {
        const response = await axios.post('mensajes/setNoLeido/' + myMensaje.id)
        return response.data
    }

    static async send(myMensaje: any): Promise<any> {
        const response = await axios.post('mensaje', myMensaje)
        return response.data
    }

    static async getUnreadCount(): Promise<number> {
        const response = await axios.get('mensajes/unread-count')
        return response.data.count || 0
    }
}